// V12.0 — validação de CPF/CNPJ (dígitos verificadores) no frontend.
export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

export function isValidCPF(v) {
  const c = onlyDigits(v);
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
  for (const i of [9, 10]) {
    let s = 0;
    for (let n = 0; n < i; n++) s += parseInt(c[n], 10) * (i + 1 - n);
    let d = (s * 10) % 11;
    if (d === 10) d = 0;
    if (d !== parseInt(c[i], 10)) return false;
  }
  return true;
}

export function isValidCNPJ(v) {
  const c = onlyDigits(v);
  if (c.length !== 14 || /^(\d)\1{13}$/.test(c)) return false;
  const calc = (len) => {
    const w = len === 12
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let s = 0;
    for (let n = 0; n < len; n++) s += parseInt(c[n], 10) * w[n];
    const r = s % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return calc(12) === parseInt(c[12], 10) && calc(13) === parseInt(c[13], 10);
}
